<template>
  <div>
    <el-row :gutter="0">
      <el-col :span="24">
        <el-row :gutter="0">
          <div class="d-flex align-items-center">
            <div>
              <span style="font-size: 13px; color: #606266">{{
                $l('query_tips_all') || '当前预算年度'
              }}</span>
              <el-divider direction="vertical"></el-divider>
            </div>
            <el-select
              v-model="curYear"
              size="small"
              :placeholder="$l('tips_select_year') || '请选择预算年度'"
              @change="query"
            >
              <el-option
                v-for="item in options"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
            <b-button
              size="sm"
              class="ml-2"
              variant="outline-success"
              @click="exportFile({ type: 'all' })"
              v-if="allow('E')"
            >
              <b-icon-arrow-down-circle></b-icon-arrow-down-circle>
              {{ $l('btn_export') || '导出' }}
            </b-button>
          </div>
        </el-row>
      </el-col>
      <!-- <el-col :span="19">
        <el-divider direction="vertical"></el-divider>
        <el-radio-group
          v-model="curType"
          fill="#317CF6"
          size="small"
          class="ml-2"
          @change="query"
        >
          <el-radio-button label="A">{{
            $l('tips_delivery_date') || '按客人下单日期'
          }}</el-radio-button>
          <el-radio-button label="B">{{
            $l('tips_shipment_date') || '按实际出货日期'
          }}</el-radio-button>
        </el-radio-group>
        <span class="statistic-caliber ml-2">{{
          curType === 'A'
            ? $l('tips_statistic_caliber_a')
            : $l('tips_statistic_caliber_b')
        }}</span>
      </el-col> -->
    </el-row>
    <el-row :gutter="10">
      <el-col :span="12">
        <StatisticsDep
          ref="listDep"
          class="mt-2"
          :form="form"
          @refresh="queryListDep"
          @exportFile="exportFile"
        />
      </el-col>
      <el-col :span="12">
        <StatisticsTeam
          ref="listTeam"
          class="mt-2"
          :form="form"
          @refresh="queryListTeam"
          @exportFile="exportFile"
        />
      </el-col>
    </el-row>
    <el-row :gutter="10">
      <el-col :span="24">
        <StatisticsTeamCust
          ref="listTeamCust"
          class="mt-2"
          :form="form"
          @refresh="queryListTeamCust"
          @exportFile="exportFile"
        />
      </el-col>
    </el-row>
  </div>
</template>
<script>
import StatisticsDep from './statistics-dep'
import StatisticsTeam from './statistics-team'
import StatisticsTeamCust from './statistics-team-cust'
import EditLoading from '@/mixins/edit-loading'

export default {
  mixins: [EditLoading],
  components: { StatisticsDep, StatisticsTeam, StatisticsTeamCust },
  props: {},
  data() {
    return {
      curYear: '',
      curType: 'A',
      form: { queryYear: '', queryType: '' },
      options: [],
    }
  },
  mounted() {
    this.getData()
  },
  methods: {
    getData() {
      this.loading = true
      this.listData = []
      this.$api.orderBudgetAnalysisGetBudgetYearApi({}).then((res) => {
        this.loading = false
        this.options = res.body.data
        this.curYear = this.options[0].value
        this.query()
      })
    },
    query() {
      this.queryListDep()
      this.queryListTeam()
      this.queryListTeamCust()
    },
    queryListDep() {
      this.form.queryYear = this.curYear
      this.form.queryType = this.curType
      this.$refs.listDep.getData(this.form)
    },
    queryListTeam() {
      this.form.queryYear = this.curYear
      this.form.queryType = this.curType
      this.$refs.listTeam.getData(this.form)
    },
    queryListTeamCust() {
      this.form.queryYear = this.curYear
      this.form.queryType = this.curType
      this.$refs.listTeamCust.getData(this.form)
    },
    exportFile({ type, searchData }) {
      let data = {}
      switch (type) {
        case 'dep':
          data = {
            type,
            ...this.form,
          }
          break
        case 'team':
          data = {
            type,
            ...this.form,
          }
          break
        case 'cust':
          data = {
            type,
            ...searchData,
            ...this.form,
          }
          break
        case 'all':
          data = {
            type,
            ...this.form,
            ...this.$refs.listTeamCust.getCustForm(),
          }
          break
        default:
          return
      }

      if (this.loadingOpen()) return
      this.$api
        .SYS_EXPORT_TASK(`factory-rpt-budget-list`, { ...data })
        .then((res) => {
          this.loadingClose()
          const { status } = res || {}
          if (200 === status) {
            this.$message({
              message:
                this.$l('INDEX.added_to_the_download_center') ||
                '导出任务已经添加到下载中心，请稍后从下载中心下载文件',
              type: 'success',
            })
            this.exportVisible = false
            return
          } else {
            this.$message.error(
              this.$l('INDEX.Description_Failed_to_add_export_task') ||
                '导出任务添加失败'
            )
          }
        })
        .catch(() => {
          this.loadingClose()
          this.$message.error(
            this.$l('INDEX.Description_Failed_to_add_export_task') ||
              '导出任务添加失败'
          )
        })
    },
  },
}
</script>
<style scoped>
.statistic-caliber {
  display: inline-block;
  font-size: 13px;
  color: #4f4f4f;
}
::v-deep .el-input {
  width: 100%;
}
</style>
